import styled from 'styled-components';

export const PdfActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  justify-content: flex-end;
`;

export const PdfActionLink = styled.a`
  background: ${(props) => props.theme.colors.primary};
  border-radius: 0.55rem;
  color: ${(props) => props.theme.colors.onPrimary};
  display: inline-flex;
  font-size: 0.9rem;
  font-weight: 600;
  line-height: 1;
  padding: 0.65rem 0.95rem;
  text-decoration: none;
  transition: opacity 0.2s ease;

  &:hover {
    color: ${(props) => props.theme.colors.surface};
    opacity: 0.92;
  }
`;

export const PdfViewport = styled.iframe<{ compact: boolean }>`
  background: #ffffff;
  border: 1px solid ${(props) => `${props.theme.colors.onSurface}18`};
  border-radius: 0.75rem;
  height: ${(props) => (props.compact ? '70vh' : '82vh')};
  min-height: ${(props) => (props.compact ? '480px' : '720px')};
  width: 100%;

  @media (max-width: 768px) {
    height: 68vh;
    min-height: 420px;
  }
`;
